module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b2189582da05ce371706002b31ae3d5.png";